import { ContractButtonLink } from "@/components/Buttons/index";
import FormatWatchPrice from "@/components/FormatWatchPrice";
import { useAdultModeQuery, useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import styles from "@/styles/Video.module.scss";
import Image from "next/image";
import Link from "next/link";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CourseInfo(_ref) {
  var withLink = _ref.withLink,
      course = _ref.course,
      isLoggedIn = _ref.isLoggedIn;
  var discountPrice = course.discount_price;
  var discountFlag = discountPrice > 0;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.course,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.courseInner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.image,
        children: course.thumbnailUrl && /*#__PURE__*/_jsx(Image, {
          src: course.thumbnailUrl,
          alt: course.name,
          width: 320,
          height: 180,
          layout: "responsive"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.name,
          children: course.name
        }), /*#__PURE__*/_jsx("div", {
          className: styles.price,
          children: /*#__PURE__*/_jsx(FormatWatchPrice, {
            price: course.price,
            type: "svod",
            isLoggedIn: isLoggedIn,
            discountPrice: discountPrice,
            discountFlag: discountFlag,
            course: course
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.description,
          children: course.description
        }), withLink && /*#__PURE__*/_jsx("div", {
          className: "".concat(styles.courseRegistBtn, " ").concat(styles.isDesktop),
          children: /*#__PURE__*/_jsx(ContractButtonLink, {
            course: course,
            className: styles.isDesktop,
            fontFixed: true
          })
        })]
      })]
    }), withLink && /*#__PURE__*/_jsx("div", {
      className: "".concat(styles.courseRegistBtn, " ").concat(styles.isNotDesktop),
      children: /*#__PURE__*/_jsx(ContractButtonLink, {
        course: course,
        fontFixed: true
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.condition,
      children: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isAndroid) && /*#__PURE__*/_jsxs("span", {
        children: ["\u203BAndroid\u7AEF\u672B\u3092\u3054\u5229\u7528\u306E\u65B9\u306F\u30D6\u30E9\u30A6\u30B6\u4E0A\u3067\u306F\u3054\u8996\u8074\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u5FC5\u305A", !adultMode && /*#__PURE__*/_jsx(Link, {
          href: config.appStoreUrl.android,
          children: "SPOOX\u30A2\u30D7\u30EA"
        }), adultMode && /*#__PURE__*/_jsx(Link, {
          href: config.firebaseDynamicLinks.adult.fallbackLink,
          children: "\u30E2\u30D0\u30A4\u30EB\u52D5\u753B\u30D7\u30EC\u30A4\u30E4\u30FC"
        }), "\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3054\u8996\u8074\u304F\u3060\u3055\u3044\u3002"]
      })
    })]
  });
}